import { render } from "./ClientRelease.vue?vue&type=template&id=55de0cd3&scoped=true"
import script from "./ClientRelease.vue?vue&type=script&lang=js"
export * from "./ClientRelease.vue?vue&type=script&lang=js"

import "./ClientRelease.vue?vue&type=style&index=0&id=55de0cd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55de0cd3"]])

export default __exports__